import React from "react";
import { MapStateToPropsParam } from "react-redux";

import { analyticsStoreEvent } from "@/mk2/actions";
import PasswordResetEmail from "@/mk2/apps/users/containers/PasswordResetEmail/PasswordResetEmail";
import { passwordResetEmailSave } from "@/mk2/apps/users/containers/PasswordResetEmail/PasswordResetEmail.actions";
import saga from "@/mk2/apps/users/containers/PasswordResetEmail/PasswordResetEmail.sagas";
import { usersPasswordResetUrl } from "@/mk2/apps/users/urls";
import { MapDispatchToPropsObject } from "@/mk2/helpers/types";
import Page, { PageRouteProps } from "@/mk2/pages/Page";
import { AppState } from "@/mk2/reducers";
import { Store } from "@/mk2/store/configureStore";
import { SEO_TITLE_PASSWORD_RESET } from "@/mk/autogenerated/translation";

interface OwnProps {}

export interface StateProps {}

export interface DispatchProps {
    onSave(usernameOrEmail: string);
    onStoreEvent(name: string, props?: any);
}

export type RouteProps = PageRouteProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class PasswordResetEmailPage extends Page<
    OwnProps & RouteProps,
    StateProps,
    DispatchProps
> {
    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            return {};
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onSave: passwordResetEmailSave,
            onStoreEvent: analyticsStoreEvent,
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_PASSWORD_RESET;
    }

    public render(props: Props): false | JSX.Element {
        return <PasswordResetEmail {...props} />;
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        return usersPasswordResetUrl;
    }

    public getSubmitButton(props: Props): React.ReactElement {
        // disabled because FormPage is used as wizard,
        // not as parent/child hierarchical form
        return null;
    }

    public getFooter(props: Props): boolean {
        // disabled because FormPage is used as wizard,
        // not as parent/child hierarchical form
        return false;
    }

    public registerInStore(store: Store<AppState>) {
        store.injectSaga("containers.users.passwordResetEmail", saga);
    }
}
